<template>
  <base-view
      @click:add="criar"
      :permiteCadastrar="permiteCadastrar"
      @update:search-values="updateSearch"
      :search-columns="searchColumns">

    <CreateEditFornecedorDialog :item="item" v-model="editDialogOpened"
                                  @onSave="() => $refs.dataTable.refresh()"/>
    <DetalheFornecedorDialog :item="item" v-model="detalheDialogOpened"/>

    <div>
      <FornecedorDataTable ref="dataTable"
                             @click:edit="editar"
                             @click:verDetalhe="verDetalhe"
                             @click:remove="remover"
                         :search-values="searchValues"/>
    </div>
    <v-overlay :value="loading" absolute>
      <v-progress-circular
        indeterminate
        color="primary"
        class="ma-4"
      ></v-progress-circular>
    </v-overlay>    
  </base-view>

</template>

<script>
import FornecedorDataTable from "../../components/shared/datatables/FornecedorDataTable";
import BaseView from "../BaseView";
import {findOne,remove} from "../../api/fornecedor";
import CreateEditFornecedorDialog from "../../components/shared/dialogs/CreateEditFornecedorDialog";
import DetalheFornecedorDialog from "../../components/shared/dialogs/DetalheFornecedorDialog";
import {ApiError} from "../../api/core";
import {mapGetters} from "vuex";
//PKs
import {findAll as findAllSetor} from "../../api/setor";
import {findAll as findAllPorte} from "../../api/porte";
import {findAll as findAllRamoAtuacao} from "../../api/ramoAtuacao";
import {findAll as findAllOferta} from "../../api/oferta";

export default {
  name: "index",
  components: {CreateEditFornecedorDialog, DetalheFornecedorDialog, BaseView, FornecedorDataTable},
  data() {
    return {
      item: null,
      loading: false,
      editDialogOpened: false,
      detalheDialogOpened: false,
      permiteCadastrar: false,
      selectedItems: [],
      searchValues: {},
      searchColumns: [
        {
          name: 'ID',
          column: 'id',
          type: 'number',
          prefix: '#'
        },
        {
          name: 'Nome',
          column: 'nome',
          type: 'text'
        },
        {
          name: 'Descricao',
          column: 'descricao',
          type: 'text'
        },
        {
          name: 'CNPJ',
          column: 'cnpj',
          type: 'text'
        },
        {
          name: 'Setor',
          column: 'idSetor',
          type: 'autocomplete',
          optionsFactory: (search) => findAllSetor(1,{
            descricao: search
          })
              .then(r => {
                return r.elements.map(e => ({
                  key: e.id,
                  valor: e.descricao
                }))
              })
        },
        {
          name: 'Porte',
          column: 'idPorte',
          type: 'autocomplete',
          optionsFactory: (search) => findAllPorte(1,{
            descricao: search
          })
              .then(r => {
                return r.elements.map(e => ({
                  key: e.id,
                  valor: e.descricao
                }))
              })
        }, 
        {
          name: 'Ramo de Atuação',
          column: 'idRamoAtuacao',
          type: 'autocomplete',
          optionsFactory: (search) => findAllRamoAtuacao(1,{
            descricao: search
          })
              .then(r => {
                return r.elements.map(e => ({
                  key: e.id,
                  valor: e.descricao
                }))
              })
        },
        {
          name: 'Oferta',
          column: 'idOferta',
          type: 'autocomplete',
          optionsFactory: (search) => findAllOferta(1,{
            descricao: search
          })
              .then(r => {
                return r.elements.map(e => ({
                  key: e.id,
                  valor: e.descricao
                }))
              })
        },        
      ]
    }
  },
  computed: {
    ...mapGetters('auth',['user','isAuthenticated','nivelUsuarioLogado']),
  },  
  methods: {
    updateSearch(search) {
      this.searchValues = search;
    },
    criar() {
      this.item = {
        id: null,
        idSetor: null,
        descricaoSetor: "",
        idPorte: null,
        descricaoPorte: "",
        idRamoAtuacao: null,
        descricaoRamoAtuacao: "",
        nomeFantasia: "",
        razaoSocial: "",
        descricao: "",
        flgEmpresaEstrangeira: "N",
        cnpj: "",
        senha: "",
        endereco: "",
        bairro: "",
        complemento: "",
        cidade: "",
        estado: "",
        cep: "",
        pais: "",
        telefone: "",
        email: "",
        siteRede: "",
        contatos: [],
        ofertas: [],
        ofertasParaCadastro: "",
        contatosParaCadastro: "",
      };
      this.editDialogOpened = true;
    },
    async getFornecedor(id){
      try {
        const retorno = await findOne(id);
        return retorno.dados[0];
      } catch (err) {
        throw err;
      }
    },
    async editar(objeto) {
      try {
        this.loading = true;
        const fornecedor = await this.getFornecedor(objeto.id);
        this.item = fornecedor;
        this.editDialogOpened = true;
      } catch (err) {
        if (err instanceof ApiError) {
          this.$toast.error(err.message, {
            timeout: 6000
          });
        } else {           
          this.$toast.error(`Não foi possível recuperar os dados do Fornecedor. Tente Novamente mais tarde.`, {
            timeout: 6000
          });
        }
      } finally {
        this.loading = false;
      }
    },
    async verDetalhe(objeto) {
      try {
        this.loading = true;
        const fornecedor = await this.getFornecedor(objeto.id);
        this.item = fornecedor;
        this.detalheDialogOpened = true;
      } catch (err) {
        if (err instanceof ApiError) {
          this.$toast.error(err.message, {
            timeout: 6000
          });
        } else {           
          this.$toast.error(`Não foi possível recuperar os dados do Fornecedor. Tente Novamente mais tarde.`, {
            timeout: 6000
          });
        }
      } finally {
        this.loading = false;
      }
    }, 
    async remover({id}) {
      try {
        this.loading = true;
        await remove(id);
        this.$toast.success(`Fornecedor removido com sucesso.`, {
          timeout: 3000
        });
        this.$refs.dataTable.refresh();
      } catch (err) {
        if (err instanceof ApiError) {
          this.$toast.error(err.message, {
            timeout: 6000
          })
        } else {        
          this.$toast.error(`Não foi possível remover o Fornecedor.`, {
            timeout: 6000
          })
        }  
      } finally {
        this.loading = false;
      }
    },
	  async getPermissoes(){
      this.permiteCadastrar = false;
    },
  },
  mounted() {
    this.getPermissoes();
  }
}
</script>

<style scoped lang="scss">

::v-deep {
  .v-data-table__wrapper {
    height: calc(100vh - 157px);
  }
}

</style>